export function formatDate(value, options = {}) {
  if (value === null || value === undefined || value === '') return '-'

  if (
    typeof value !== 'string' &&
    typeof value !== 'number' &&
    !(value instanceof Date)
  ) {
    return '-'
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)

  const {
    withTime = false,
    locale = 'ru-RU',
  } = options

  return date.toLocaleString(locale, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    ...(withTime
      ? { hour: '2-digit', minute: '2-digit' }
      : {}),
  })
}
